import { Controller } from "@hotwired/stimulus"

// 同意画面:
// - すべてのチェックが入るまで開始ボタンを無効化
// - 送信時にマイク許可を事前取得（面談画面での遅延・失敗を減らす）。
//   拒否されてもテキストフォールバックで継続できるため送信は止めない。
export default class extends Controller {
  static targets = ["checkbox", "submit", "micConsent"]

  connect() {
    this.update()
  }

  update() {
    const allChecked = this.checkboxTargets.every((cb) => cb.checked)
    this.submitTarget.disabled = !allChecked
  }

  async submit(event) {
    if (this.micRequested) return // 許可取得済み → そのまま送信

    event.preventDefault()
    this.submitTarget.disabled = true
    this.submitTarget.value = "マイクの確認中…"

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      stream.getTracks().forEach((track) => track.stop()) // 権限だけ取得して即解放
      this.micConsentTarget.value = "1"
    } catch {
      this.micConsentTarget.value = "0" // 拒否・非対応 → テキストモードで継続
    }

    this.micRequested = true
    this.element.requestSubmit() // このコントローラはform要素自身に付与されている
  }
}
